import { gql } from '@apollo/client';

export const GET_UNIQUE_VEHICLES_VS_ACTIVE_LISTINGS_HISTORY = gql`
  query GetUniqueVehiclesVsActiveListingsHistory($vendorNames: [String!]!) {
    getUniqueVehiclesVsActiveListingsHistory(vendorNames: $vendorNames) {
      dateISO8601
      uniqueVehiclesAmount
      activeListingsAmount
    }
  }
`;
